// This file is included from several places (layout/theme.liquid, the product
// tab snippet, collapsible-content, main-faqs-page...). A <script src> runs
// every time it appears in the DOM, so the whole file is wrapped and the
// element registration is guarded to make repeat execution harmless.
if (!customElements.get('faqs-item')) {

    class FAQs extends HTMLElement {
        constructor() {
            super();

            this.filter = document.getElementById('haloFAQsFilter');
            this.faqsPopup = document.getElementById('halo-faqs-popup');

            if (this.filter) {
                this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
                this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
                this.filterDropdownArrow = this.filterToggle
                    ? this.filterToggle.querySelector('[data-dropdown-arrow]')
                    : null;

                if (this.filterToggle) {
                    this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
                }

                if (this.filterDropdown && this.filterDropdown.querySelector('.text')) {
                    this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
                        filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                    });
                }

                // Only worth listening for outside clicks when there is a
                // dropdown to close. Without this guard the handler ran on
                // every page that has an <faqs-item> but no filter UI.
                if (this.filterDropdown && !document.body.classList.contains('template-index')) {
                    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
                }
            }

            if (this.querySelector('.faqs')) {
                this.querySelectorAll('.card-header').forEach((headerButton) => {
                    headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
                });
            }
        }

        onClickFilterHandler() {
            if (!this.filterDropdown) return;

            if (this.filterDropdown.classList.contains('is-show')) {
                this.filterDropdown.classList.remove('is-show');
                if (this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
            } else {
                this.filterDropdown.classList.add('is-show');
                if (this.filterDropdownArrow) this.filterDropdownArrow.classList.add('active');
            }
        }

        onClickFilterButtonHandler(event) {
            var btn = event.target.closest('li');
            if (!btn || btn.classList.contains('is-active')) return;

            var filterValue = btn.getAttribute('data-value'),
                filterText = event.target.innerText;

            if (this.filterToggle && this.filterToggle.querySelector('.text')) {
                this.filterToggle.querySelector('.text').innerText = filterText;
            }

            if (this.filterDropdown) {
                this.filterDropdown.querySelectorAll('li').forEach((element) => {
                    element.classList.remove('is-active');
                });
            }

            btn.classList.add('is-active');

            if (filterValue !== undefined && filterValue !== null) {
                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    var id = element.getAttribute('id');

                    if (id == filterValue) {
                        element.classList.remove('is-hidden');
                        element.classList.add('is-active');
                    } else {
                        element.classList.remove('is-active');
                        element.classList.add('is-hidden');
                    }
                });
            } else {
                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    element.classList.remove('is-hidden', 'is-active');
                });
            }

            if (this.filterDropdown) this.filterDropdown.classList.remove('is-show');
            if (this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
        }

        onClickHeaderButtonHandler(event) {
            const btn = event.currentTarget;
            if (!btn) return;

            const content = btn.nextElementSibling;

            btn.classList.toggle('collapsed');
            if (!content) return;

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        }

        onBodyClickEvent(event) {
            // Synthetic clicks (variants.js fires one on the media nodes when
            // the variant changes) reach this with no filter UI in the page.
            if (!this.filterDropdown) return;
            if (event.target.closest('[data-faqs-filter]') != null) return;

            if (this.filterDropdown.classList.contains('is-show')) {
                this.filterDropdown.classList.remove('is-show');
                if (this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
            }
        }
    }

    customElements.define('faqs-item', FAQs);
}